import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'isValidDate',
})
export class IsValidDatePipe implements PipeTransform {
  public transform(dateString: string | null): boolean {
    if (!dateString) return false;
    return dayjs(dateString).isValid();
  }
}
